import { z } from "zod";
import { ConstructionType } from "../enums/ConstructionType";
import { ProgramType } from "../enums/ProgramType";
import { ProjectStatus } from "../enums/ProjectStatus";
import { Signature } from "../enums/Signature";
import { dateSchema } from "../utils/DateSchema";
import { idSchema } from "../utils/IdSchema";
import { nameSchema } from "../utils/NameSchema";
import { requiredStringSchema } from "../utils/RequiredStringSchema";
import { AddressSchema } from "./Address";

export const ProjectSchema = z.object({
  id: idSchema(),
  name: requiredStringSchema().max(250),
  source: z.object({
    id: idSchema(),
    name: requiredStringSchema().max(250),
  }),
  status: ProjectStatus,
  startDate: dateSchema().optional(),
  endDate: dateSchema().optional(),
  address: AddressSchema.optional(),
  programType: ProgramType.optional(),
  constructionType: ConstructionType.optional(),
  contractors: z.array(nameSchema()),
  descriptionOfOperations: z.string().max(2000).optional(),
  estimatedSalesValue: z.number().optional(),
  constructionValue: z.number().optional(),
  firstNamedInsureds: z.array(nameSchema()),
  authorizedRepresentative: nameSchema().optional(),
  signature: Signature.optional(),
  projectContacts: z.array(nameSchema()),
  updatedDate: dateSchema().optional(),
});

export type Project = z.infer<typeof ProjectSchema>;
